import { render, staticRenderFns } from "./InvoicesDetailSection.vue?vue&type=template&id=72e4495c&scoped=true&"
import script from "./InvoicesDetailSection.vue?vue&type=script&lang=js&"
export * from "./InvoicesDetailSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e4495c",
  null
  
)

export default component.exports